import { Theme } from "@emotion/react";
import { SvgIconTypeMap, SxProps } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";

interface Column {
  id: string;
  label: string;
  minWidth?: number;
  align?: "left" | "right" | "center";
  leftIcon?: OverridableComponent<SvgIconTypeMap<"svg">>;
  rightIcon?: OverridableComponent<SvgIconTypeMap<"svg">>;
  format?: (val: number | string) => string;
  sx?: SxProps<Theme>;
}


export const COLUMNS: readonly Column[] = [
  {
    id: "tripId",
    label: "Trip ID",
    minWidth: 100,
    align: "center",
  },
  {
    id: "title",
    label: "Trip Title",
    minWidth: 150,
    align: "center",
  },
  // { id: "slotId", label: "Slot Id", minWidth: 200, align: "center" },
  {id:"bookingStatus", label: "Booking Status", minWidth: 150, align: "center" },
  { id: "startDate", label: "Start Date", minWidth: 100, align: "center" },
  { id: "bookingAmount", label: "Total Booking Amount", minWidth: 150, align: "center" },
  { id: "numberofTravellers", label: "Number of Travellers", minWidth: 150, align: "center" },
  { id: "createdAt", label: "Created At", minWidth: 150, align: "center" }
];

export interface BookingDetailsType {
  razorpayPaymentStatus: string;
  paymentId: string;
  fareGST: number;
  pickupLocation: string;
  priceTiers: {
    name: string;
    numberOfSeats: number;
    tierId: number;
    price: string;
  }[];
  status: string;
  convenienceFeesWithGST: number;
  name: string;
  travellerDetails: any[]; // Can be replaced with a defined type if you have traveller details structure
  coupon: string;
  isReviewGiven: boolean;
  priceBreakUp: {
    couponDiscount: string;
    discountedPrice: string;            //Discounted Price
    totalPrice: string;                 
    grandTotal: string;                 //
    gst: string;                        //gst
    convenience: string;
    convenienceGST: string;
  };
  transactionAmountRazorpay: number;
  paymentStatus: string;
  searchIdKey: string;
  hostId: string;
  userId: string;
  isPaymentTriggeredByDev: boolean;
  numberOfTravellers: number;
  walletBalance: string;
  searchId: string;
  bookingStatus: string;
  id: string;
  phone: string;
  totalTripCost: number;                // Final cost of the trip included all taxes
  totalPrice: number;                   // Actual Cost before discount          
  appliedCoupon: {
    message: string;
    data: {
      referralRewardAmount: number;
      originalAmount: number;
      referrerId: string;
      couponType: string;
      cashbackAmount: number;
      description: string;
      discountAmount: number;
      finalPrice: number;
      title: string;
      couponCode: string;
    };
    success: boolean;
  };
  convenienceFees: number;
  slotEndDate: string;
  tripLocation: {
    destination: {
      country: string;
      state: string;
      district: string;
    }[];
    startLoc: {
      country: string;
      state: string;
      district: string;
    }[];
    endLoc: {
      country: string;
      state: string;
      district: string;
    }[];
  };
  createdAt: string;
  slotStartDate: string;
  transactionId: string;
  tripId: string;
  coverImage: string;
  slotId: string;
  dropLocation: string;
  useWalletCash: boolean;
  updatedAt: string;
  tripTitle: string;
  merchantId: string;
  tripIdDisplay: string;
}
